import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Image } from "../Image";
import "./style.scss";

export const EnhancedImage = forwardRef(({
    alt = "",
    style = {},
    quality = 100,
    src,
    width,
    height,
    className,
    otherParams = {},
    onLoadSuccess = () => {},
    defaultLoad = true,
    type = "webp",
    onClick = () => {},
    onMouseEnter = () => {},
    onMouseLeave = () => {},
    updateRef = () => {},
    formatSize = 1,
    // 新增属性
    showLoadingPlaceholder = true,
    loadingPlaceholder = null,
    fadeInOnLoad = true,
    preload = false,
    onLoadStart = () => {},
    onLoadError = () => {},
}, ref) => {
    const [isLoaded, setIsLoaded] = useState(defaultLoad && !preload);
    const [hasError, setHasError] = useState(false);
    const [showImage, setShowImage] = useState(!fadeInOnLoad);
    const imageRef = React.useRef(null);

    useImperativeHandle(ref, () => ({
        updateSrc: () => {},
        reload: () => {
            setIsLoaded(false);
            setHasError(false);
            setShowImage(!fadeInOnLoad);
        }
    }));

    useEffect(() => {
        if (imageRef) {
            updateRef(imageRef, setIsLoaded);
        }
    }, [imageRef]);

    const handleLoad = () => {
        setIsLoaded(true);
        setHasError(false);
        if (fadeInOnLoad) {
            // 延迟显示图片，实现淡入效果
            setTimeout(() => {
                setShowImage(true);
            }, 50);
        }
        onLoadSuccess();
    };

    const handleError = () => {
        setHasError(true);
        setIsLoaded(false);
        onLoadError();
    };

    const handleLoadStart = () => {
        onLoadStart();
    };

    if (!src) return null;

    return (
        <div 
            className={`enhanced-image-container ${className || ''}`}
            style={{ position: 'relative', ...style }}
        >
            {/* 加载占位符 */}
            {showLoadingPlaceholder && !isLoaded && !hasError && (
                <div className="image-loading-placeholder">
                    {loadingPlaceholder || (
                        <div className="default-loading-placeholder">
                            <div className="loading-spinner"></div>
                        </div>
                    )}
                </div>
            )}
            
            {/* 错误占位符 */}
            {hasError && (
                <div className="image-error-placeholder">
                    <div className="error-icon">⚠️</div>
                    <div className="error-text">Failed to load</div>
                </div>
            )}

            {/* 实际图片 */}
            <Image
                ref={imageRef}
                src={src}
                alt={alt}
                width={width}
                height={height}
                quality={quality}
                otherParams={otherParams}
                defaultLoad={defaultLoad}
                type={type}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                updateRef={updateRef}
                formatSize={formatSize}
                onLoadSuccess={handleLoad}
                className={className}
                style={{
                    ...style,
                    opacity: showImage ? 1 : 0,
                    transition: fadeInOnLoad ? 'opacity 0.3s ease-in-out' : 'none',
                    position: hasError ? 'absolute' : 'relative',
                    top: hasError ? '-9999px' : 'auto',
                    left: hasError ? '-9999px' : 'auto'
                }}
            />
        </div>
    );
});

EnhancedImage.propTypes = {};
